<template>
    <div class="a-textarea">
        <template v-if="label">
            <span class="label">
                {{ label }}<span v-if="required" class="red">*</span>
            </span>
        </template>
        <template v-if="validation">
            <ValidationProvider
                v-slot="{ errors }"
                v-bind="validationConfig"
                mode="eager"
            >
                <b-form-textarea
                    ref="textArea"
                    v-model="localValue"
                    :class="{
                        'has-errors': errors.length > 0,
                    }"
                    v-bind="$attrs"
                    v-shortkey="shortKeyConfig" 
                    @shortkey="shortKeyHandler"
                />
                <span class="error">{{ errors[0] }}</span>
            </ValidationProvider>
        </template>
        <template v-else>
            <b-form-textarea v-model="localValue" v-bind="$attrs" ref="textArea"/>
        </template>
    </div>
</template>

<script>
import { Input } from 'view-design'
import { ValidationProvider } from 'vee-validate'

export default {
    name: 'ATextarea',
    components: {
        ValidationProvider,
    },
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        validation: {
            type: Boolean,
            default: false,
        },
        validationConfig: {
            type: Object,
            default: () => {},
        },
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        shortKeyConfig: {
            type: Array
        }
    },
    methods: {
        shortKeyHandler(val) {
            this.$emit('shortkey', val)    
        },
        focus() {
            if (this.$refs.textArea) {
                this.$refs.textArea.focus()
            }
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
